'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageUpload = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var ImageUpload = function ImageUpload(_ref) {
  var label = _ref.label,
      image = _ref.image,
      onImageUpload = _ref.onImageUpload,
      validate = _ref.validate,
      className = _ref.className,
      props = (0, _objectWithoutProperties3.default)(_ref, ['label', 'image', 'onImageUpload', 'validate', 'className']);

  var onImageChange = function onImageChange(_ref2) {
    var files = _ref2.target.files;

    var reader = new FileReader();
    reader.onload = function () {
      onImageUpload(reader.result);
    };

    reader.readAsDataURL(files[0]);
  };

  var onImageRemove = function onImageRemove() {
    onImageUpload(null);
  };

  return _react2.default.createElement('div', (0, _extends3.default)({
    className: (0, _classnames2.default)(className, 'frm-Form_ImageUpload', {
      'frm-Form-validate': validate
    })
  }, props), _react2.default.createElement('input', {
    className: 'frm-Form_ImageUploadInput',
    type: 'file',
    onChange: onImageChange,
    accept: 'image/*'
  }), _react2.default.createElement('div', { className: 'frm-Form_ImageUploadContent' }, image ? _react2.default.createElement('img', { className: 'frm-Form_ImageUploadImage', src: image }) : _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('span', { className: 'frm-Form_ImageUploadIcon am-icon-camera' }), label && _react2.default.createElement('p', { className: 'frm-Form_ImageUploadMessage util-Ma-t3' }, label))), image && _react2.default.createElement('span', {
    className: 'frm-Form_ImageUploadRemove am-icon-close-thin',
    onClick: function onClick() {
      return onImageRemove();
    }
  }));
};

ImageUpload.defaultProps = {
  label: undefined,
  validate: false,
  className: undefined
};

ImageUpload.propTypes = {
  label: _propTypes2.default.string,
  image: _propTypes2.default.string,
  onImageUpload: _propTypes2.default.func.isRequired,
  validate: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

exports.ImageUpload = ImageUpload;